import {
  processManagerAutomationLegalRequirementChangeSchema,
  processManagerAutomationEmailToLegalClientSchema,
  processManagerAutomationEmailToExternalSchema,
  IProcessManagerAutomationLegalRequirementChange,
  IProcessManagerAutomationEmailToLegalClient,
  IProcessManagerAutomationEmailToExternal,
} from '../Interfaces/IProcessManagerAutomation';

export function isPMAutomationLegalRequirementChange(
  data: unknown
): data is IProcessManagerAutomationLegalRequirementChange {
  return processManagerAutomationLegalRequirementChangeSchema.safeParse(data)
    .success;
}

export function isPMAutomationEmailToLegalClient(
  data: unknown
): data is IProcessManagerAutomationEmailToLegalClient {
  return processManagerAutomationEmailToLegalClientSchema.safeParse(data)
    .success;
}

export function isPMAutomationEmailToExternal(
  data: unknown
): data is IProcessManagerAutomationEmailToExternal {
  return processManagerAutomationEmailToExternalSchema.safeParse(data).success;
}
